import classNames from 'classnames'
import Image from '@dustin-web/microsite-components/src/image'
import { getRelativeProductImageUrl } from '@dustin-web/microsite-components/src/utils/urls'

import './product-variant-image-selector.scss'

type Props = {
  index: number
  isSelected: boolean
  href: string
  variantPrimaryImageId: string
  variantDisplayName: string
  variantColorName: string
  onButtonClick: () => void
}

const imageSize = { width: 60, height: 60 } as const

const ProductVariantImageSelector = ({
  href,
  isSelected,
  variantPrimaryImageId,
  variantDisplayName,
  variantColorName,
  onButtonClick,
}: Props) => {
  const imageSrc = getRelativeProductImageUrl(
    variantPrimaryImageId,
    imageSize.width,
    imageSize.height,
    variantDisplayName ?? ''
  )

  return (
    <a
      href={href}
      role="radio"
      aria-checked={isSelected}
      aria-label={`${variantColorName}, ${variantDisplayName}`}
      onClickCapture={e => {
        e.preventDefault()
        e.stopPropagation()
        onButtonClick()
      }}
      className={classNames('product-variant-image-selector-button', {
        selected: isSelected,
      })}>
      <Image
        draggable={false}
        width={imageSize.width}
        height={imageSize.width}
        src={imageSrc}
        alt={variantDisplayName}
      />
    </a>
  )
}

export default ProductVariantImageSelector
